import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getFactorCategoryId } from "./items"
import { getStartDate, getEndDate } from "./dates"

const getPositionSetName = (_, props) => props.positionSetName
const getViewType = (_, props) => props.viewType

export const getFileName = createSelector(
  [getPositionSetName, getFactorCategoryId, getViewType, getStartDate, getEndDate],
  (positionSetName, factorCategoryId, viewType, startDate, endDate) => `${positionSetName} ${capitalize(factorCategoryId)} ${capitalize(viewType)} Performance ${startDate} - ${endDate}`,
)
